
import { useState } from "react";
import { Card } from "@material-ui/core";
import { Button, Divider, Grid, MenuItem, TextField, Typography } from "@mui/material";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../../utils/buttonLeft";
import FazerObservacoes from "../../../../components/fazerObservacoes.";
import TextoFormatado from "../../../../../utils/textoFormatado";
import AddImagens from "./addImagens";


export default function AnalisePh({ avaliacaoId, ficha, analises, handleClose }) {
    // const { avaliacaoId } = useParams()
    const dispatch = useDispatch()
    const [avaliacao, setAvaliacao] = useState()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);

    function HandleChange(e) {
        setAvaliacao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitAvaliacao = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(avaliacao)

        const formData = new FormData();
        formData.append('userId', user?._id);
        formData.append('avaliacaoAnaliticaId', avaliacaoId);
        formData.append('observacao', obs);
        formData.append('referencia', avaliacao?.referencia ?? '');
        formData.append('resultado', avaliacao?.resultado ?? '');
        formData.append('amostra', avaliacao?.amostra ?? '');
        if (avaliacao?.imagens) {
            for (let imagem of avaliacao?.imagens) { formData.append('imagens', imagem ?? ''); }
        }

        await api.patch('/avalicao-analitica/teste/ph', formData)
            .then(res => {
                setMessageSuccess(res.data.msg)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Análise inserida com sucesso' },
                });
                handleClose();

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    return (
        <Card style={{ padding: 15, marginTop: 20, minWidth: 700 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs title={'Analise de PH'} />
            {ficha ?
                analises.map((analise) => (
                    <div key={analise._id}>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Referência:</strong> {analise?.referencia ?? '####'}</Typography>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Amostra:</strong> {analise?.amostra ?? '####'}</Typography>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Resultado:</strong> {analise?.resultado ?? '####'}</Typography>
                        <br />
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Observação:</strong>  <TextoFormatado texto={analise?.observacao ?? ''} /> </Typography>

                        <AddImagens avaliacao={analise} />
                        <Divider />
                        <br />
                    </div>
                ))
                :
                <>
                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Referência"
                                fullWidth
                                size="small"
                                name="referencia"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.referencia}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Amostra"
                                fullWidth
                                size="small"
                                name="amostra"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.amostra}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Resultado"
                                select
                                fullWidth
                                size="small"
                                name="resultado"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.resultado || ''}
                            >
                                <MenuItem value={'Aprovado'} name="resultado">
                                    Aprovado
                                </MenuItem>
                                <MenuItem value={'Reprovado'} name="resultado">
                                    Reprovado
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <FazerObservacoes setObs={setObs} obs={obs} titulo={''} />

                    <AddImagens
                        addImagens={true}
                        avaliacao={avaliacao}
                        setAvaliacao={setAvaliacao}
                    />

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submitAvaliacao}
                        load={open}
                    >
                        <Button onClick={handleClose} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}